import { ReferralParticipationCriteriaSection } from '../types/';

import Button from 'components/buttons/Button';
import Spacing from 'components/spacing/Spacing';

import { SectionTitle as H2 } from './SectionTitle';
import { twMerge } from 'tailwind-merge';

const SectionTitle = ({ title }: { title: string }) => {
  return <div className="tw-font-jost tw-text-[20px] tw-font-bold tw-text-[#1FB563]">{title}</div>;
};

const SectionDescription = ({ description }: { description: string }) => {
  return <p className="tw-font-jost tw-text-[12px] tw-leading-[32px] tw-text-white lg:tw-text-[15px]">{description}</p>;
};

type AnalyticsParticipationCriteriaProps = {
  participationCriteria: ReferralParticipationCriteriaSection[];
  onClickJoinNow: () => void;
  className?: string;
};

export const AnalyticsParticipationCriteria = ({
  participationCriteria,
  onClickJoinNow,
  className,
}: AnalyticsParticipationCriteriaProps) => {
  return (
    <div className={twMerge('tw-flex tw-flex-col tw-items-center tw-bg-[#101010] tw-font-jost', className)}>
      <H2>Participation Criteria</H2>
      <Spacing height={40} />
      <div className="tw-flex tw-w-full tw-max-w-[1280px] tw-flex-col tw-gap-[20px] tw-px-[20px] tw-text-left lg:tw-gap-[15px] lg:tw-px-0">
        {participationCriteria.map((section, idx) => (
          <div key={idx} className="tw-flex tw-flex-col tw-gap-[20px] lg:tw-gap-[15px]">
            <SectionTitle title={section.title} />
            {section.description && <SectionDescription description={section.description} />}
          </div>
        ))}
        <Button
          text="Join Now"
          size="medium"
          color="referral-cta"
          className="tw-self-center lg:tw-w-[180px]"
          contentClassName="tw-text-[15px] lg:tw-text-[20px] tw-normal-case"
          onClick={onClickJoinNow}
        />
      </div>
    </div>
  );
};
